import { SvgProps } from "components/icons/types";

export const CertificateWatermark = (props: SvgProps) => (
  <svg
    {...props}
    width="77"
    height="85"
    viewBox="0 0 77 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_40_29200)">
      <path
        d="M75.4144 -14.8564L21.916 -9.23348C20.7796 -9.11404 19.9552 -8.09598 20.0747 -6.95958L27.1393 60.2564C27.2588 61.3928 28.2768 62.2172 29.4132 62.0977L82.9117 56.4748C84.0481 56.3554 84.8725 55.3373 84.753 54.2009L77.6883 -13.015C77.5689 -14.1514 76.5508 -14.9758 75.4144 -14.8564Z"
        stroke="#F3F3F5"
        strokeWidth="1.37931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5306 3.83533L69.3115 -0.345812M30.2515 10.6941L70.0324 6.51296M30.9724 17.5529L58.4075 14.6693"
        stroke="#F3F3F5"
        strokeWidth="1.37931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5069 37.9849C37.2875 31.4516 41.1123 41.4514 44.723 36.2177C47.106 32.5 50.1008 41.2001 53.7114 35.9664C56.1666 32.9346 59.5589 38.8191 62.4116 32.9717C64.1809 30.0119 66.671 33.9109 68.5845 32.3229"
        stroke="#F3F3F5"
        strokeWidth="1.37931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.0001 46.3597L72.4092 42.3228"
        stroke="#F3F3F5"
        strokeWidth="1.37931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4483 69.8276C30.6851 69.8276 36.5517 63.961 36.5517 56.7242C36.5517 49.4873 30.6851 43.6207 23.4483 43.6207C16.2115 43.6207 10.3448 49.4873 10.3448 56.7242C10.3448 63.961 16.2115 69.8276 23.4483 69.8276Z"
        stroke="#F3F3F5"
        strokeWidth="1.7931"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="1.03 3.45"
      />
      <path
        d="M23.4483 66.3793C28.7807 66.3793 33.1034 62.0565 33.1034 56.7241C33.1034 51.3917 28.7807 47.069 23.4483 47.069C18.1159 47.069 13.7931 51.3917 13.7931 56.7241C13.7931 62.0565 18.1159 66.3793 23.4483 66.3793Z"
        stroke="#F3F3F5"
        strokeWidth="1.37931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4483 62.2414C26.4954 62.2414 28.9655 59.7712 28.9655 56.7242C28.9655 53.6771 26.4954 51.2069 23.4483 51.2069C20.4012 51.2069 17.931 53.6771 17.931 56.7242C17.931 59.7712 20.4012 62.2414 23.4483 62.2414Z"
        stroke="#F3F3F5"
        strokeWidth="1.37931"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="2.07 2.41"
      />
      <path
        d="M17.9311 67.7587L15.1725 80.8621L23.4483 76.0345L31.7242 80.8621L28.9656 67.7587"
        stroke="#F3F3F5"
        strokeWidth="1.37931"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_40_29200">
        <rect
          width="96.5517"
          height="100"
          fill="white"
          transform="translate(0 -15)"
        />
      </clipPath>
    </defs>
  </svg>
);
